import { Contact } from "../../../shared-gen/Model/Locations/Contact";

export class ContactFun {

	static createNew(): Contact {
		return {
			Name: '',
			Mail: '',
			Phone: ''
		}
	}

	static toText(_this: Contact): string {
		var ret = _this.Name;
		if (_this.Phone || _this.Mail) {
			ret += " (";
			if (_this.Phone)
				ret += "Tel.: " + _this.Phone;
			if (_this.Phone && _this.Mail)
				ret += " , ";
			if (_this.Mail)
				ret += "E-Mail: " + _this.Mail;
			ret += ")";
		}
		return ret;
	}

}
